import { graphql } from '@/gql';
import type { SubmitOrderRateMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const submitOrderRate = async ({ id, data }: SubmitOrderRateMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
    },
    mutation: graphql(`
      mutation SubmitOrderRate($id: String!, $data: OrderRateInfoInput!) {
        submitOrderRate(id: $id, data: $data) {
          id
          rateInfo {
            submittedAt
            submitById
            rateList {
              target {
                targetType
                targetId
              }
              starRating
              reviewText
              tagList {
                tagId
                tagName
              }
            }
          }
        }
      }
    `),
  });

  return response.data?.submitOrderRate;
};
